import axios from 'axios';
import { ROOT_API_URL } from '../../../api-config';
import { loader, toastr } from '../CommonActions';
import { auth } from '../../../services/auth.service';

export const GET_ALL_EVENTS = 'GET_ALL_EVENTS';
export const SAVE_EVENT = 'SAVE_EVENT';
export const DELETE_EVENT = 'DELETE_EVENT';

const successColor = 'success';
const errorColor = 'danger';
const warningColor = 'warning';

export function fetchAllEvents() {
	return function(dispatch) {
		dispatch(loader(true));
		axios
			.get(`${ROOT_API_URL}/ManageEvents/GetAllEvents`, { headers: auth.authHeader() })
			.then((response) => {
				dispatch({
					type: GET_ALL_EVENTS,
					payload: response.data
				});
				dispatch(loader(false));
			})
			.catch((response) => {
				var err = response && response.data ? response.data.message : 'Network Connection Error';
				dispatch(loader(false));
				dispatch(toastr(true, err, errorColor));
			});
	};
}

export function saveEvent(model) {
	return function(dispatch) {
		dispatch(loader(true));
		axios
			.post(`${ROOT_API_URL}/ManageEvents/SaveEvent`, model, { headers: auth.authHeader() })
			.then(function(response) {
				if (response && response.data && response.data.issuccess) {
					dispatch({
						type: SAVE_EVENT,
						payload: response.data.events
					});
					var success = response && response.data ? response.data.message : 'Event Created Successfully';
					dispatch(toastr(true, success, successColor));
				}
				else {
					var err = response.data.message ? response.data.message: "Error Creating Event"; 
					dispatch(toastr(true,err, warningColor));
				}  
				dispatch(loader(false));
			})
			.catch((response) => {
				var err = response && response.data ? response.data.message : 'Network Connection Error';
				dispatch(loader(false));
				dispatch(toastr(true, err, errorColor));
			});
	};
}

export function deleteEvent(model) {
	return function(dispatch) {
		dispatch(loader(true));
		axios
			.post(`${ROOT_API_URL}/ManageEvents/ToggleEvent`, model, { headers: auth.authHeader() })
			.then(function(response) {
				if (response && response.data && response.data.issuccess) {
					dispatch({
						type: DELETE_EVENT,
						payload: response.data.events
					});
					var success = response && response.data ? response.data.message : 'Event Created Successfully';
						dispatch(toastr(true, success, successColor));
					}
				dispatch(loader(false));
			})
			.catch((response) => {
				var err = response && response.data ? response.data.message : 'Network Connection Error';
				dispatch(loader(false));
				dispatch(toastr(true, err, errorColor));
			});
	};
}
